import React, { useState } from 'react'

function Calc({fields}) {
    const [Moy, setMoy] = useState();
    const [Score, setScore] = useState();


    function calc(event) {
        event.preventDefault()
        const moy = ()=>{
            let s = 0;
            let r = 0;
            all.forEach(el => {
                if(el.name ==="Option" && el.value < 10){
                    console.log("option is under 10")
                }else{
                    r+= Number(el.dataset.fois);
                    s+= (Number(el.value) * el.dataset.fois);
                    val = {
                        ...val,
                        [el.name] : Number(el.value)
                    }
                    console.log(s)
                }
            });
         
            return s / r;
        }


        const all = document.querySelectorAll(".fields input");
        let val = {}
        let result = moy();
        let score = eval(fields.formule); 
        console.log(val)
        setMoy(result)
        setScore(score)
    }


  return (
    <div>
        <h1>Bac {fields.field}</h1>
        <form  onSubmit={calc}>
        <div className='fields'>
        {fields.matieres.map((el)=>(
            <input key={el.name} name={el.name} type="number" min="0" max="20" step=".01" placeholder={el.name} data-fois={el.fois} required/>
        ))}
    </div>
    <div><button className="btn" type="submit">Calculer</button></div>
        </form>
        {Score && <div className='last' >
            <div className='score'>Votre Score : {Score.toFixed(2)}</div>
            <div className='score'>Votre Moyenne : {Moy.toFixed(2)}</div>
            <div className='score'>Score avec 7% : {(Score + (Score * 7 / 100)).toFixed(2)}</div>
            </div>}
    </div>
  )
}

export default Calc